var _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModel3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.78,
    y: 242.62,
    width: 22.4,
    height: 94.96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.12,
    y: 210.24,
    width: 22.4,
    height: 127.34,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.46,
    y: 242.62,
    width: 22.4,
    height: 94.96,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.1,
    y: 274.99,
    width: 22.4,
    height: 62.58,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.44,
    y: 259.36,
    width: 22.4,
    height: 78.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.8,
    y: 274.99,
    width: 22.4,
    height: 62.58,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.49,
    y: 177.86,
    width: 22.4,
    height: 159.72,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.14,
    y: 242.62,
    width: 22.4,
    height: 94.96,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.15,
    y: 210.24,
    width: 22.4,
    height: 127.34,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.82,
    y: 226.98,
    width: 22.4,
    height: 110.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.48,
    y: 259.36,
    width: 22.4,
    height: 78.21,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.91,
    cy: 212.4,
    r: 15.63,
    transform: "translate(-154.41 229.7) rotate(-76.72)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.79,
    cy: 212.4,
    r: 15.63,
    transform: "translate(-129.75 111.56) rotate(-45)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.79,
    cy: 212.4,
    r: 11.7,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.93,214.89c.45,2.59-1.33,4.32-4.53,4.59l-.05,2.14H68.4l.06-2.14a10.86,10.86,0,0,1-4.74-1.5l.88-2.41A8.84,8.84,0,0,0,68.52,217l.09-3.28c-1.91-.55-4-1.27-4.43-3.62-.45-2.59,1.36-4.34,4.63-4.57l0-2.14H70.8l0,2.16a9.91,9.91,0,0,1,3.78,1.11L73.76,209a7.48,7.48,0,0,0-3.07-1l-.08,3.42C72.49,212,74.53,212.66,74.93,214.89Zm-6.27-4,.08-2.8c-1.07.21-1.59.81-1.48,1.55S67.91,210.59,68.66,210.89Zm3.2,4.51c-.09-.57-.6-.92-1.33-1.17l-.06,2.66C71.49,216.68,72,216.14,71.86,215.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.17,
    y: 80.48,
    width: 96.37,
    height: 45.74,
    rx: 7.49,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.69,
    y: 86.71,
    width: 8.22,
    height: 33.92,
    rx: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.19,
    y: 86.71,
    width: 8.22,
    height: 33.92,
    rx: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.4,
    y: 97.9,
    width: 8.22,
    height: 22.74,
    rx: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.17,
    y: 103.35,
    width: 8.22,
    height: 17.28,
    rx: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.8,
    y: 116.63,
    width: 8.22,
    height: 4,
    rx: 0.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.42,86.51a.73.73,0,0,0-1,.38l-12,26a.73.73,0,0,1-1.3.1L403,96.07a.73.73,0,0,0-1-.23L388,101.44a.72.72,0,0,1-.75,0L372,86.08a.72.72,0,0,0-1,.34l0,.08a.73.73,0,0,0,.31.93l16.07,15.83a.7.7,0,0,0,.75,0L401.51,98a.72.72,0,0,1,1,.23l11.83,18.07a.73.73,0,0,0,1.3-.09l13.1-28.75A.74.74,0,0,0,428.42,86.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.2,
    cy: 108.78,
    r: 16.31,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.01,
    cy: 108.78,
    r: 13.09,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.97,
    cy: 109.87,
    r: 1.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.82 110.36 215.19 105.06 215.74 104.48 220.84 109.28 229.98 101.2 230.51 101.8 220.82 110.36",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-39",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.2,
    y: 242.7,
    width: 66.02,
    height: 173.73,
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.2,
    y: 242.7,
    width: 49.23,
    height: 173.73,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.45,
    y: 301.93,
    width: 66.02,
    height: 114.49,
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.24,
    y: 301.66,
    width: 49.23,
    height: 114.77,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.53,
    y: 273.68,
    width: 66.02,
    height: 142.74,
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.32,
    y: 273.33,
    width: 49.23,
    height: 143.09,
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.23,416.61c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S156.32,414.49,156.23,416.61Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.58,
    y: 400.13,
    width: 3.85,
    height: 30.42,
    transform: "translate(-250.73 569.06) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39,412.76c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S156.48,410.64,156.39,412.76Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.39,412.76c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S156.48,410.64,156.39,412.76Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,412.7a.62.62,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.71s12.13,1.49,13,2.82a.54.54,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S158.39,411.26,158.33,412.7Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,412.7a.62.62,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.71s12.13,1.49,13,2.82a.54.54,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S158.39,411.26,158.33,412.7Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,413.08c.91,1.33,6.38,2.53,13,2.81s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.82S159.48,411.83,158.46,413.08Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,410.78c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S153.13,408.66,153,410.78Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.39,
    y: 394.3,
    width: 3.85,
    height: 30.42,
    transform: "translate(-247.96 560.31) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2,406.94c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S153.29,404.81,153.2,406.94Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.2,406.94c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S153.29,404.81,153.2,406.94Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,406.87a.57.57,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S155.2,405.43,155.14,406.87Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,406.87a.57.57,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S155.2,405.43,155.14,406.87Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.27,407.25c.9,1.33,6.38,2.53,13,2.81s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.81S156.28,406,155.27,407.25Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.45,403.76c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S153.54,401.64,153.45,403.76Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.8,
    y: 387.28,
    width: 3.85,
    height: 30.42,
    transform: "translate(-240.55 553.99) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,399.91c-.09,2.13,6.64,4.14,15,4.5s15.26-1.08,15.35-3.2-6.64-4.14-15-4.5S153.7,397.79,153.61,399.91Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,399.91c-.09,2.13,6.64,4.14,15,4.5s15.26-1.08,15.35-3.2-6.64-4.14-15-4.5S153.7,397.79,153.61,399.91Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.55,399.85a.62.62,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.52.52,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S155.61,398.41,155.55,399.85Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.55,399.85a.62.62,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.52.52,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S155.61,398.41,155.55,399.85Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,400.23c.91,1.33,6.38,2.53,13,2.81s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.81S156.7,399,155.68,400.23Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,397.94c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S150.35,395.81,150.26,397.94Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.61,
    y: 381.45,
    width: 3.85,
    height: 30.42,
    transform: "translate(-237.79 545.2) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42,394.09c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S150.51,392,150.42,394.09Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42,394.09c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S150.51,392,150.42,394.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,394a.55.55,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S152.42,392.58,152.36,394Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,394a.55.55,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S152.42,392.58,152.36,394Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.49,394.4c.9,1.33,6.38,2.53,13,2.81s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.81S153.5,393.15,152.49,394.4Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,393c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S155.22,390.87,155.13,393Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 376.51,
    width: 3.85,
    height: 30.42,
    transform: "translate(-228.18 545.36) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,389.15c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S155.39,387,155.3,389.15Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,389.15c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S155.39,387,155.3,389.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,389.08a.67.67,0,0,0,.13.38c1-1.25,6.58-2,13.21-1.7s12.14,1.48,13,2.81a.58.58,0,0,0,.17-.36c.06-1.44-5.82-2.89-13.15-3.2S157.3,387.64,157.23,389.08Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.23,389.08a.67.67,0,0,0,.13.38c1-1.25,6.58-2,13.21-1.7s12.14,1.48,13,2.81a.58.58,0,0,0,.17-.36c.06-1.44-5.82-2.89-13.15-3.2S157.3,387.64,157.23,389.08Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.36,389.46c.91,1.33,6.38,2.53,13,2.81s12.22-.45,13.21-1.7c-.88-1.33-6.36-2.53-13-2.81S158.38,388.21,157.36,389.46Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,387.17c-.09,2.12,6.64,4.14,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S152,385,151.94,387.17Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.29,
    y: 370.68,
    width: 3.85,
    height: 30.42,
    transform: "translate(-225.42 536.58) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,383.32c-.09,2.12,6.64,4.14,15,4.49s15.27-1.07,15.36-3.2-6.64-4.14-15-4.5S152.19,381.19,152.1,383.32Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,383.32c-.09,2.12,6.64,4.14,15,4.49s15.27-1.07,15.36-3.2-6.64-4.14-15-4.5S152.19,381.19,152.1,383.32Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,383.25a.58.58,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.82a.56.56,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.2S154.1,381.81,154,383.25Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,383.25a.58.58,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.82a.56.56,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.2S154.1,381.81,154,383.25Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.17,383.63c.91,1.33,6.38,2.53,13,2.82s12.21-.45,13.21-1.7c-.89-1.34-6.36-2.54-13-2.82S155.19,382.38,154.17,383.63Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.91,414.75c-.1,2.13,6.63,4.14,15,4.49s15.26-1.07,15.35-3.2-6.63-4.14-15-4.49S111,412.62,110.91,414.75Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.26,
    y: 398.26,
    width: 3.85,
    height: 30.42,
    transform: "translate(-292.27 521.99) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,410.9c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S111.16,408.77,111.07,410.9Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,410.9c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S111.16,408.77,111.07,410.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,410.83a.53.53,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.49,13,2.82a.65.65,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S113.07,409.39,113,410.83Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,410.83a.53.53,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.49,13,2.82a.65.65,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S113.07,409.39,113,410.83Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.14,411.21c.9,1.33,6.38,2.54,13,2.82s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.54-13-2.82S114.15,410,113.14,411.21Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.13,411c-.5,2.07,5.73,5.32,13.9,7.26s15.2,1.84,15.69-.23-5.74-5.32-13.91-7.26S124.62,408.93,124.13,411Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.44,
    y: 397.43,
    width: 3.85,
    height: 30.42,
    transform: "translate(-294.32 452.76) rotate(-76.62)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,407.25c-.5,2.07,5.73,5.32,13.9,7.27s15.2,1.84,15.69-.23S148.88,409,140.7,407,125.51,405.18,125,407.25Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,407.25c-.5,2.07,5.73,5.32,13.9,7.27s15.2,1.84,15.69-.23S148.88,409,140.7,407,125.51,405.18,125,407.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,407.55a.57.57,0,0,0,.06.4c1.23-1,6.83-.7,13.29.84s11.63,3.76,12.25,5.23a.59.59,0,0,0,.23-.33c.33-1.4-5.17-3.93-12.31-5.63S127.27,406.15,126.93,407.55Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,407.55a.57.57,0,0,0,.06.4c1.23-1,6.83-.7,13.29.84s11.63,3.76,12.25,5.23a.59.59,0,0,0,.23-.33c.33-1.4-5.17-3.93-12.31-5.63S127.27,406.15,126.93,407.55Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,408c.64,1.48,5.78,3.7,12.25,5.23s12.07,1.88,13.29.84c-.62-1.47-5.77-3.69-12.25-5.23S128.22,406.91,127,408Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.7,
    cy: 372.2,
    r: 13.7,
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.34,
    cy: 372.2,
    r: 13.7,
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.34,
    cy: 372.2,
    r: 13.7,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.34,
    cy: 372.2,
    r: 10.26,
    transform: "translate(-215.05 225.22) rotate(-45)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.49,375.59a4.27,4.27,0,0,1-3.21,1.3A4.46,4.46,0,0,1,161,374.1h5.52v-1.18H160.7a4.89,4.89,0,0,1,0-.54,4.75,4.75,0,0,1,0-.54h5.81v-1.18H161a4.46,4.46,0,0,1,4.29-2.79,4.27,4.27,0,0,1,3.21,1.29l.16.16,1.11-1.09-.15-.16a5.8,5.8,0,0,0-4.39-1.74,6,6,0,0,0-6,4.33h-1.95v1.18H159c0,.18,0,.36,0,.54s0,.36,0,.54h-1.74v1.18h1.95a6,6,0,0,0,6,4.33,5.81,5.81,0,0,0,4.39-1.76l.15-.16-1.11-1.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,418.49c-.08,2.12-6.94,3.6-15.34,3.3s-15.13-2.27-15.06-4.39,6.95-3.61,15.34-3.31S356.35,416.36,356.27,418.49Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.22,
    y: 400.81,
    width: 3.85,
    height: 30.42,
    transform: "translate(-86.83 742.03) rotate(-87.95)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41,414.64c-.08,2.12-6.94,3.6-15.34,3.3s-15.13-2.27-15.06-4.39,6.94-3.61,15.34-3.31S356.49,412.51,356.41,414.64Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.41,414.64c-.08,2.12-6.94,3.6-15.34,3.3s-15.13-2.27-15.06-4.39,6.94-3.61,15.34-3.31S356.49,412.51,356.41,414.64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.48,414.42a.56.56,0,0,1-.16.37c-.91-1.33-6.39-2.5-13-2.73s-12.21.53-13.2,1.78a.59.59,0,0,1-.14-.37c.06-1.44,6-2.42,13.36-2.16S354.53,413,354.48,414.42Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.48,414.42a.56.56,0,0,1-.16.37c-.91-1.33-6.39-2.5-13-2.73s-12.21.53-13.2,1.78a.59.59,0,0,1-.14-.37c.06-1.44,6-2.42,13.36-2.16S354.53,413,354.48,414.42Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.32,414.79c-1,1.25-6.56,2-13.2,1.78s-12.14-1.4-13-2.73c1-1.25,6.54-2,13.2-1.78S353.41,413.46,354.32,414.79Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.91,412.93c-.08,2.12-6.94,3.6-15.34,3.3s-15.13-2.27-15.06-4.4,6.95-3.6,15.34-3.3S360,410.8,359.91,412.93Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.85,
    y: 395.25,
    width: 3.85,
    height: 30.42,
    transform: "translate(-77.79 740.28) rotate(-87.94)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.05,409.08c-.08,2.12-6.94,3.6-15.34,3.3s-15.14-2.27-15.06-4.4,6.94-3.6,15.34-3.3S360.12,407,360.05,409.08Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.05,409.08c-.08,2.12-6.94,3.6-15.34,3.3s-15.14-2.27-15.06-4.4,6.94-3.6,15.34-3.3S360.12,407,360.05,409.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.12,408.86a.52.52,0,0,1-.16.36c-.91-1.32-6.39-2.49-13-2.72s-12.22.53-13.2,1.78a.59.59,0,0,1-.14-.37c.06-1.44,6-2.42,13.36-2.16S358.17,407.42,358.12,408.86Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.12,408.86a.52.52,0,0,1-.16.36c-.91-1.32-6.39-2.49-13-2.72s-12.22.53-13.2,1.78a.59.59,0,0,1-.14-.37c.06-1.44,6-2.42,13.36-2.16S358.17,407.42,358.12,408.86Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,409.22c-1,1.26-6.56,2-13.2,1.79s-12.14-1.4-13-2.73c1-1.25,6.54-2,13.2-1.78S357.05,407.9,358,409.22Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.05,405.89c-.08,2.13-6.95,3.61-15.34,3.31s-15.14-2.27-15.06-4.4,6.94-3.6,15.34-3.3S360.12,403.77,360.05,405.89Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.99,
    y: 388.21,
    width: 3.85,
    height: 30.42,
    transform: "translate(-70.63 733.64) rotate(-87.94)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,402c-.08,2.13-6.95,3.61-15.34,3.31s-15.14-2.27-15.06-4.4,6.94-3.6,15.33-3.3S360.26,399.92,360.19,402Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,402c-.08,2.13-6.95,3.61-15.34,3.31s-15.14-2.27-15.06-4.4,6.94-3.6,15.33-3.3S360.26,399.92,360.19,402Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,401.83a.62.62,0,0,1-.16.36c-.92-1.32-6.4-2.49-13-2.73s-12.21.53-13.2,1.79a.58.58,0,0,1-.13-.38c0-1.44,6-2.41,13.36-2.15S358.31,400.39,358.26,401.83Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.26,401.83a.62.62,0,0,1-.16.36c-.92-1.32-6.4-2.49-13-2.73s-12.21.53-13.2,1.79a.58.58,0,0,1-.13-.38c0-1.44,6-2.41,13.36-2.15S358.31,400.39,358.26,401.83Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.1,402.19c-1,1.26-6.56,2-13.2,1.79s-12.14-1.4-13-2.73c1-1.26,6.54-2,13.2-1.79S357.18,400.87,358.1,402.19Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.69,400.33c-.08,2.13-6.95,3.61-15.34,3.31s-15.14-2.27-15.06-4.4,6.94-3.6,15.34-3.3S363.76,398.21,363.69,400.33Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.63,
    y: 382.65,
    width: 3.85,
    height: 30.42,
    transform: "translate(-61.54 731.94) rotate(-87.95)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,396.48c-.07,2.13-6.94,3.61-15.33,3.31s-15.14-2.27-15.06-4.4,6.94-3.6,15.33-3.3S363.9,394.36,363.82,396.48Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,396.48c-.07,2.13-6.94,3.61-15.33,3.31s-15.14-2.27-15.06-4.4,6.94-3.6,15.33-3.3S363.9,394.36,363.82,396.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,396.27a.62.62,0,0,1-.16.36c-.92-1.32-6.4-2.49-13-2.73s-12.21.53-13.2,1.79a.58.58,0,0,1-.13-.38c.05-1.44,6-2.41,13.36-2.15S362,394.83,361.9,396.27Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.9,396.27a.62.62,0,0,1-.16.36c-.92-1.32-6.4-2.49-13-2.73s-12.21.53-13.2,1.79a.58.58,0,0,1-.13-.38c.05-1.44,6-2.41,13.36-2.15S362,394.83,361.9,396.27Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.74,396.63c-1,1.26-6.56,2-13.2,1.79s-12.14-1.4-13-2.73c1-1.26,6.54-2,13.2-1.79S360.82,395.31,361.74,396.63Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,414.21c-.09,2.13,6.63,4.14,15,4.5s15.26-1.08,15.35-3.21-6.63-4.14-15-4.49S243.06,412.09,243,414.21Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.32,
    y: 397.72,
    width: 3.85,
    height: 30.42,
    transform: "translate(-165.28 653.42) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,410.36c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S243.22,408.24,243.13,410.36Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.13,410.36c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S243.22,408.24,243.13,410.36Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07,410.3a.53.53,0,0,0,.13.37c1-1.25,6.57-2,13.21-1.7s12.13,1.49,13,2.82a.65.65,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S245.13,408.86,245.07,410.3Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.07,410.3a.53.53,0,0,0,.13.37c1-1.25,6.57-2,13.21-1.7s12.13,1.49,13,2.82a.65.65,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S245.13,408.86,245.07,410.3Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2,410.67c.9,1.34,6.38,2.54,13,2.82s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.82S246.21,409.42,245.2,410.67Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.77,408.38c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S239.86,406.26,239.77,408.38Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.12,
    y: 391.89,
    width: 3.85,
    height: 30.42,
    transform: "translate(-162.5 644.67) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.94,404.53c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S240,402.41,239.94,404.53Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.94,404.53c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S240,402.41,239.94,404.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,404.47a.7.7,0,0,0,.13.38c1-1.25,6.58-2,13.21-1.71s12.14,1.49,13,2.82a.6.6,0,0,0,.17-.37c.06-1.44-5.82-2.88-13.15-3.19S241.94,403,241.87,404.47Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,404.47a.7.7,0,0,0,.13.38c1-1.25,6.58-2,13.21-1.71s12.14,1.49,13,2.82a.6.6,0,0,0,.17-.37c.06-1.44-5.82-2.88-13.15-3.19S241.94,403,241.87,404.47Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,404.85c.91,1.33,6.38,2.53,13,2.81s12.22-.45,13.21-1.7c-.88-1.33-6.36-2.53-13-2.82S243,403.6,242,404.85Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,401.36c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S240.28,399.24,240.19,401.36Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.54,
    y: 384.87,
    width: 3.85,
    height: 30.42,
    transform: "translate(-155.09 638.35) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35,397.51c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S240.44,395.39,240.35,397.51Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35,397.51c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.14-15-4.49S240.44,395.39,240.35,397.51Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29,397.45a.53.53,0,0,0,.13.37c1-1.24,6.57-2,13.21-1.7s12.13,1.49,13,2.82a.65.65,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S242.35,396,242.29,397.45Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29,397.45a.53.53,0,0,0,.13.37c1-1.24,6.57-2,13.21-1.7s12.13,1.49,13,2.82a.65.65,0,0,0,.16-.37c.06-1.44-5.82-2.88-13.15-3.19S242.35,396,242.29,397.45Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42,397.82c.9,1.34,6.38,2.54,13,2.82s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.82S243.43,396.58,242.42,397.82Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,395.53c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S237.08,393.41,237,395.53Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.34,
    y: 379.05,
    width: 3.85,
    height: 30.42,
    transform: "translate(-152.34 629.56) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.16,391.68c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S237.25,389.56,237.16,391.68Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.16,391.68c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S237.25,389.56,237.16,391.68Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,391.62a.61.61,0,0,0,.12.38c1-1.25,6.58-2,13.22-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.37c.06-1.43-5.82-2.88-13.15-3.19S239.16,390.18,239.1,391.62Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1,391.62a.61.61,0,0,0,.12.38c1-1.25,6.58-2,13.22-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.37c.06-1.43-5.82-2.88-13.15-3.19S239.16,390.18,239.1,391.62Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.22,392c.91,1.33,6.38,2.53,13,2.81s12.22-.45,13.22-1.7c-.89-1.33-6.37-2.53-13-2.81S240.24,390.75,239.22,392Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,390.59c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S242,388.47,241.87,390.59Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.22,
    y: 374.11,
    width: 3.85,
    height: 30.42,
    transform: "translate(-142.72 629.72) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,386.74c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S242.12,384.62,242,386.74Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,386.74c-.09,2.13,6.64,4.14,15,4.5s15.27-1.08,15.36-3.21-6.64-4.13-15-4.49S242.12,384.62,242,386.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,386.68a.62.62,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.52.52,0,0,0,.16-.37c.06-1.43-5.82-2.88-13.15-3.19S244,385.24,244,386.68Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,386.68a.62.62,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.52.52,0,0,0,.16-.37c.06-1.43-5.82-2.88-13.15-3.19S244,385.24,244,386.68Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,387.06c.91,1.33,6.38,2.53,13,2.81s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.81S245.12,385.81,244.1,387.06Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.68,384.77c-.09,2.12,6.64,4.13,15,4.49s15.26-1.08,15.36-3.2-6.64-4.14-15-4.5S238.77,382.64,238.68,384.77Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.03,
    y: 368.28,
    width: 3.85,
    height: 30.42,
    transform: "translate(-139.97 620.94) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84,380.92c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S238.93,378.79,238.84,380.92Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84,380.92c-.09,2.12,6.64,4.13,15,4.49s15.27-1.08,15.36-3.2-6.64-4.14-15-4.5S238.93,378.79,238.84,380.92Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,380.85a.55.55,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S240.84,379.41,240.78,380.85Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.78,380.85a.55.55,0,0,0,.13.38c1-1.25,6.57-2,13.21-1.7s12.13,1.48,13,2.81a.62.62,0,0,0,.16-.36c.06-1.44-5.82-2.89-13.15-3.2S240.84,379.41,240.78,380.85Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.91,381.23c.9,1.33,6.38,2.53,13,2.81s12.21-.45,13.21-1.7c-.89-1.33-6.36-2.53-13-2.81S241.92,380,240.91,381.23Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.25,380.63c.09,2.12-6.64,4.14-15,4.49S242,384,241.86,381.92s6.63-4.14,15-4.5S272.15,378.5,272.25,380.63Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.76,
    y: 377.42,
    width: 30.42,
    height: 3.85,
    transform: "matrix(1, -0.04, 0.04, 1, -15.87, 11.25)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,376.78c.09,2.12-6.64,4.14-15,4.49s-15.27-1.07-15.36-3.2,6.64-4.14,15-4.5S272,374.65,272.08,376.78Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,376.78c.09,2.12-6.64,4.14-15,4.49s-15.27-1.07-15.36-3.2,6.64-4.14,15-4.5S272,374.65,272.08,376.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.14,376.71a.53.53,0,0,1-.13.38c-1-1.25-6.57-2-13.21-1.7s-12.13,1.48-13,2.82a.68.68,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S270.08,375.27,270.14,376.71Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.14,376.71a.53.53,0,0,1-.13.38c-1-1.25-6.57-2-13.21-1.7s-12.13,1.48-13,2.82a.68.68,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S270.08,375.27,270.14,376.71Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,377.09c-.9,1.33-6.38,2.53-13,2.82s-12.21-.45-13.21-1.7c.89-1.34,6.36-2.54,13-2.82S269,375.84,270,377.09Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.44,374.8c.09,2.13-6.64,4.14-15,4.49s-15.27-1.07-15.36-3.2,6.64-4.14,15-4.49S275.35,372.67,275.44,374.8Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.95,
    y: 371.59,
    width: 30.42,
    height: 3.85,
    transform: "translate(-15.6 11.36) rotate(-2.43)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,371c.09,2.13-6.63,4.14-15,4.5s-15.26-1.08-15.35-3.21,6.63-4.14,15-4.49S275.18,368.82,275.27,371Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,371c.09,2.13-6.63,4.14-15,4.5s-15.26-1.08-15.35-3.21,6.63-4.14,15-4.49S275.18,368.82,275.27,371Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.34,370.88a.65.65,0,0,1-.13.38c-1-1.25-6.58-2-13.21-1.7s-12.14,1.49-13,2.82a.54.54,0,0,1-.16-.37c-.07-1.44,5.82-2.88,13.14-3.19S273.27,369.44,273.34,370.88Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.34,370.88a.65.65,0,0,1-.13.38c-1-1.25-6.58-2-13.21-1.7s-12.14,1.49-13,2.82a.54.54,0,0,1-.16-.37c-.07-1.44,5.82-2.88,13.14-3.19S273.27,369.44,273.34,370.88Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,371.26c-.91,1.33-6.38,2.54-13,2.82s-12.22-.45-13.21-1.7c.88-1.33,6.36-2.54,13-2.82S272.19,370,273.21,371.26Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,367.78c.09,2.12-6.63,4.14-15,4.49s-15.26-1.07-15.35-3.2,6.63-4.14,15-4.5S274.93,365.65,275,367.78Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.54,
    y: 364.57,
    width: 30.42,
    height: 3.85,
    transform: "translate(-15.31 11.35) rotate(-2.43)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,363.93c.09,2.13-6.64,4.14-15,4.49s-15.27-1.07-15.36-3.2,6.64-4.14,15-4.49S274.77,361.8,274.86,363.93Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.86,363.93c.09,2.13-6.64,4.14-15,4.49s-15.27-1.07-15.36-3.2,6.64-4.14,15-4.49S274.77,361.8,274.86,363.93Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,363.86a.53.53,0,0,1-.13.38c-1-1.25-6.57-2-13.21-1.7s-12.13,1.49-13,2.82a.68.68,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S272.86,362.42,272.92,363.86Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.92,363.86a.53.53,0,0,1-.13.38c-1-1.25-6.57-2-13.21-1.7s-12.13,1.49-13,2.82a.68.68,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S272.86,362.42,272.92,363.86Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.79,364.24c-.9,1.33-6.38,2.54-13,2.82s-12.21-.45-13.21-1.7c.89-1.33,6.36-2.54,13-2.82S271.78,363,272.79,364.24Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.22,362c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.14,15-4.49S278.13,359.82,278.22,362Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.73,
    y: 358.74,
    width: 30.42,
    height: 3.85,
    transform: "translate(-15.08 11.49) rotate(-2.43)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,358.1c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.14,15-4.49S278,356,278.05,358.1Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.05,358.1c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.14,15-4.49S278,356,278.05,358.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.12,358a.64.64,0,0,1-.13.37c-1-1.25-6.58-2-13.21-1.7s-12.14,1.49-13,2.82a.6.6,0,0,1-.17-.37c-.06-1.44,5.82-2.88,13.15-3.19S276.05,356.6,276.12,358Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.12,358a.64.64,0,0,1-.13.37c-1-1.25-6.58-2-13.21-1.7s-12.14,1.49-13,2.82a.6.6,0,0,1-.17-.37c-.06-1.44,5.82-2.88,13.15-3.19S276.05,356.6,276.12,358Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,358.41c-.91,1.34-6.38,2.54-13,2.82s-12.22-.45-13.21-1.7c.88-1.33,6.36-2.54,13-2.82S275,357.16,276,358.41Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.34,357c.09,2.13-6.64,4.14-15,4.5S243,360.43,243,358.3s6.64-4.14,15-4.49S273.25,354.89,273.34,357Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.86,
    y: 353.8,
    width: 30.42,
    height: 3.85,
    transform: "translate(-14.85 11.26) rotate(-2.43)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,353.16c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.14,15-4.49S273.09,351,273.18,353.16Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,353.16c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.14,15-4.49S273.09,351,273.18,353.16Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.24,353.1a.53.53,0,0,1-.13.37c-1-1.25-6.57-2-13.21-1.7s-12.13,1.49-13,2.82a.59.59,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S271.18,351.66,271.24,353.1Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.24,353.1a.53.53,0,0,1-.13.37c-1-1.25-6.57-2-13.21-1.7s-12.13,1.49-13,2.82a.59.59,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S271.18,351.66,271.24,353.1Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.11,353.47c-.91,1.34-6.38,2.54-13,2.82s-12.21-.45-13.21-1.7c.89-1.33,6.36-2.53,13-2.82S270.09,352.22,271.11,353.47Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,351.18c.09,2.13-6.64,4.14-15,4.5s-15.26-1.08-15.35-3.21,6.63-4.14,15-4.49S276.44,349.06,276.54,351.18Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.05,
    y: 347.98,
    width: 30.42,
    height: 3.85,
    transform: "translate(-14.61 11.4) rotate(-2.43)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.37,347.33c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.13,15-4.49S276.28,345.21,276.37,347.33Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.37,347.33c.09,2.13-6.64,4.14-15,4.5s-15.27-1.08-15.36-3.21,6.64-4.13,15-4.49S276.28,345.21,276.37,347.33Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,347.27a.57.57,0,0,1-.13.38c-1-1.25-6.57-2-13.21-1.71s-12.13,1.49-13,2.82a.65.65,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S274.37,345.83,274.43,347.27Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,347.27a.57.57,0,0,1-.13.38c-1-1.25-6.57-2-13.21-1.71s-12.13,1.49-13,2.82a.65.65,0,0,1-.16-.37c-.06-1.44,5.82-2.88,13.15-3.19S274.37,345.83,274.43,347.27Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.3,347.65c-.9,1.33-6.38,2.53-13,2.81s-12.21-.45-13.21-1.7c.89-1.33,6.36-2.53,13-2.82S273.29,346.4,274.3,347.65Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.08,
    cy: 333.97,
    r: 13.7,
    transform: "translate(-100.76 112.22) rotate(-20.55)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.58,
    cy: 334.65,
    r: 13.7,
    transform: "translate(-163.16 316.22) rotate(-49.6)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.58,
    cy: 334.65,
    r: 13.7,
    transform: "translate(-163.16 316.22) rotate(-49.6)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.91,338.89a10.25,10.25,0,1,1-5.09-13.58A10.26,10.26,0,0,1,269.91,338.89Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.33,337.69a3.09,3.09,0,0,0-1-1.6,2.77,2.77,0,0,0,1.46-.49,2.89,2.89,0,0,0,1-1.2,2.6,2.6,0,0,0-.12-2.48,4.68,4.68,0,0,0-1.73-1.61l.35-.77-1.18-.53-.32.71-1.18-.54.32-.71-1.18-.54-.32.72-2.56-1.17-4.8,10.57,2.55,1.17-.34.75,1.18.53.34-.75,1.18.54-.34.75,1.18.53.36-.78a5.35,5.35,0,0,0,2.84.43,2.68,2.68,0,0,0,2-1.64A2.9,2.9,0,0,0,265.33,337.69Zm-4.84-7.26,2.43,1.11a2.72,2.72,0,0,1,1.23.93,1.13,1.13,0,0,1,0,1.14,1.11,1.11,0,0,1-.89.72,2.64,2.64,0,0,1-1.52-.3l-2.43-1.11Zm1.32,8.53a2.94,2.94,0,0,1-1.6-.35l-2.85-1.29,1.18-2.62,2.86,1.3c1.29.59,1.74,1.33,1.35,2.2A1.2,1.2,0,0,1,261.81,339Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.7,412.22c-.31,1.25-4.55,1.26-9.47,0s-8.66-3.25-8.35-4.49,4.56-1.26,9.48,0S390,411,389.7,412.22Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.91,
    y: 399.68,
    width: 2.33,
    height: 18.37,
    transform: "translate(-108.11 679.2) rotate(-75.94)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.27,410c-.32,1.25-4.56,1.26-9.48,0s-8.65-3.24-8.34-4.49,4.55-1.26,9.47,0S390.58,408.72,390.27,410Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.27,410c-.32,1.25-4.56,1.26-9.48,0s-8.65-3.24-8.34-4.49,4.55-1.26,9.47,0S390.58,408.72,390.27,410Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,409.59a.31.31,0,0,1-.14.2c-.37-.9-3.46-2.28-7.35-3.25s-7.28-1.22-8-.6a.5.5,0,0,1,0-.24c.22-.85,3.87-.67,8.17.4S389.37,408.75,389.15,409.59Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.15,409.59a.31.31,0,0,1-.14.2c-.37-.9-3.46-2.28-7.35-3.25s-7.28-1.22-8-.6a.5.5,0,0,1,0-.24c.22-.85,3.87-.67,8.17.4S389.37,408.75,389.15,409.59Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,409.79c-.75.61-4.12.37-8-.6s-7-2.36-7.36-3.25c.75-.62,4.12-.38,8,.6S388.64,408.89,389,409.79Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.26,416.32c.06,1.28-4,2.5-9.08,2.71s-9.22-.65-9.27-1.93,4-2.5,9.08-2.72S398.21,415,398.26,416.32Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.85,
    y: 414.38,
    width: 18.37,
    height: 2.33,
    transform: "translate(-17.29 16.89) rotate(-2.43)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,414c.06,1.29-4,2.5-9.07,2.72s-9.22-.65-9.28-1.94,4-2.5,9.08-2.71S398.11,412.71,398.16,414Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.16,414c.06,1.29-4,2.5-9.07,2.72s-9.22-.65-9.28-1.94,4-2.5,9.08-2.71S398.11,412.71,398.16,414Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,414a.29.29,0,0,1-.08.23c-.61-.75-4-1.2-8-1s-7.33.9-7.87,1.7a.34.34,0,0,1-.09-.22c0-.87,3.51-1.74,7.94-1.93S397,413.08,397,414Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,414a.29.29,0,0,1-.08.23c-.61-.75-4-1.2-8-1s-7.33.9-7.87,1.7a.34.34,0,0,1-.09-.22c0-.87,3.51-1.74,7.94-1.93S397,413.08,397,414Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.91,414.18c-.54.8-3.85,1.53-7.86,1.7s-7.37-.27-8-1c.54-.8,3.85-1.53,7.87-1.7S396.3,413.43,396.91,414.18Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.16,
    cy: 404.27,
    r: 13.7,
    transform: "translate(-167.78 497.69) rotate(-56.72)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.62,414.48a13.7,13.7,0,1,1-1.11-19.34A13.7,13.7,0,0,1,388.62,414.48Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.62,414.48a13.7,13.7,0,1,1-1.11-19.34A13.7,13.7,0,0,1,388.62,414.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,412.19a10.26,10.26,0,1,1-.83-14.48A10.25,10.25,0,0,1,386,412.19Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.3,410c-1.22,2-3.39,2.05-5.64.36l-1.28,1.37-1.28-1.13,1.29-1.37a9.4,9.4,0,0,1-2.23-3.74l2-1.07a7.82,7.82,0,0,0,1.76,3.19l2-2.1c-.93-1.46-1.89-3.17-.79-4.95,1.21-1.95,3.42-2,5.69-.29l1.29-1.37,1.27,1.14-1.29,1.38a8.57,8.57,0,0,1,1.82,2.93L383,405.47a6.67,6.67,0,0,0-1.42-2.46l-2.05,2.2C380.41,406.65,381.34,408.3,380.3,410Zm-1.76-6.27,1.68-1.79c-.83-.49-1.52-.4-1.88.15A1.65,1.65,0,0,0,378.54,403.72Zm-.54,4.82a1.53,1.53,0,0,0-.19-1.54l-1.6,1.7C377,409.15,377.65,409.09,378,408.54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.78,417.59c-.05,1.28,4,2.5,9.08,2.71s9.22-.65,9.27-1.93-4-2.5-9.07-2.72S208.84,416.3,208.78,417.59Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.84,
    y: 407.63,
    width: 2.33,
    height: 18.37,
    transform: "translate(-207.67 616.96) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,415.26c-.06,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.08-2.71S208.93,414,208.88,415.26Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.88,415.26c-.06,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.08-2.71S208.93,414,208.88,415.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.05,415.22a.38.38,0,0,0,.08.23c.61-.75,4-1.2,8-1s7.32.9,7.86,1.71a.4.4,0,0,0,.1-.23c0-.87-3.52-1.74-7.94-1.92S210.09,414.35,210.05,415.22Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.05,415.22a.38.38,0,0,0,.08.23c.61-.75,4-1.2,8-1s7.32.9,7.86,1.71a.4.4,0,0,0,.1-.23c0-.87-3.52-1.74-7.94-1.92S210.09,414.35,210.05,415.22Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.13,415.45c.55.81,3.85,1.53,7.86,1.7s7.38-.27,8-1c-.54-.81-3.84-1.53-7.86-1.71S210.74,414.7,210.13,415.45Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,414.07c0,1.28,4,2.5,9.08,2.71s9.22-.65,9.27-1.93-4-2.5-9.07-2.72S206.91,412.79,206.85,414.07Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.91,
    y: 404.11,
    width: 2.33,
    height: 18.37,
    transform: "translate(-206.02 611.63) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,411.74c0,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.07-2.71S207,410.46,207,411.74Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,411.74c0,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.07-2.71S207,410.46,207,411.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,411.7a.38.38,0,0,0,.08.23c.61-.75,4-1.19,8-1s7.32.89,7.86,1.7a.4.4,0,0,0,.1-.23c0-.86-3.52-1.74-7.94-1.92S208.16,410.83,208.12,411.7Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,411.7a.38.38,0,0,0,.08.23c.61-.75,4-1.19,8-1s7.32.89,7.86,1.7a.4.4,0,0,0,.1-.23c0-.86-3.52-1.74-7.94-1.92S208.16,410.83,208.12,411.7Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.2,411.93c.55.81,3.85,1.53,7.86,1.7s7.38-.27,8-1c-.54-.81-3.84-1.53-7.86-1.7S208.81,411.18,208.2,411.93Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.1,409.83c0,1.28,4,2.5,9.08,2.71s9.22-.65,9.27-1.93-4-2.5-9.07-2.72S207.16,408.55,207.1,409.83Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.16,
    y: 399.87,
    width: 2.33,
    height: 18.37,
    transform: "translate(-201.55 607.82) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2,407.5c0,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.07-2.71S207.26,406.22,207.2,407.5Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2,407.5c0,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.07-2.71S207.26,406.22,207.2,407.5Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,407.46a.38.38,0,0,0,.08.23c.61-.75,4-1.19,8-1s7.32.89,7.86,1.7a.4.4,0,0,0,.1-.23c0-.86-3.52-1.74-7.94-1.92S208.41,406.6,208.37,407.46Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,407.46a.38.38,0,0,0,.08.23c.61-.75,4-1.19,8-1s7.32.89,7.86,1.7a.4.4,0,0,0,.1-.23c0-.86-3.52-1.74-7.94-1.92S208.41,406.6,208.37,407.46Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.45,407.69c.55.81,3.85,1.53,7.86,1.7s7.38-.27,8-1c-.54-.81-3.84-1.53-7.86-1.7S209.06,406.94,208.45,407.69Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,406.31c0,1.28,4,2.5,9.08,2.71s9.22-.65,9.28-1.93-4-2.5-9.08-2.72S205.23,405,205.17,406.31Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.24,
    y: 396.35,
    width: 2.33,
    height: 18.37,
    transform: "translate(-199.87 602.54) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,404c-.05,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.49-9.07-2.71S205.33,402.7,205.27,404Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,404c-.05,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.49-9.07-2.71S205.33,402.7,205.27,404Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,403.94a.38.38,0,0,0,.08.23c.62-.75,4-1.19,8-1s7.33.89,7.86,1.7a.34.34,0,0,0,.1-.22c0-.87-3.52-1.75-7.94-1.93S206.48,403.08,206.44,403.94Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,403.94a.38.38,0,0,0,.08.23c.62-.75,4-1.19,8-1s7.33.89,7.86,1.7a.34.34,0,0,0,.1-.22c0-.87-3.52-1.75-7.94-1.93S206.48,403.08,206.44,403.94Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52,404.17c.55.81,3.85,1.53,7.86,1.7s7.38-.27,8-1c-.53-.81-3.84-1.53-7.86-1.7S207.14,403.42,206.52,404.17Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,403.33c-.06,1.28,4,2.5,9.08,2.71s9.22-.65,9.27-1.93-4-2.5-9.08-2.72S208.17,402,208.12,403.33Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.18,
    y: 393.37,
    width: 2.33,
    height: 18.37,
    transform: "translate(-194.08 602.61) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.22,401c-.06,1.29,4,2.5,9.07,2.72s9.22-.65,9.28-1.94-4-2.5-9.08-2.71S208.27,399.72,208.22,401Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.22,401c-.06,1.29,4,2.5,9.07,2.72s9.22-.65,9.28-1.94-4-2.5-9.08-2.71S208.27,399.72,208.22,401Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.39,401a.29.29,0,0,0,.08.23c.61-.75,4-1.2,8-1s7.33.9,7.87,1.7a.34.34,0,0,0,.09-.22c0-.87-3.51-1.74-7.94-1.93S209.42,400.09,209.39,401Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.39,401a.29.29,0,0,0,.08.23c.61-.75,4-1.2,8-1s7.33.9,7.87,1.7a.34.34,0,0,0,.09-.22c0-.87-3.51-1.74-7.94-1.93S209.42,400.09,209.39,401Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.47,401.19c.54.8,3.85,1.53,7.86,1.7s7.37-.27,8-1c-.54-.8-3.85-1.53-7.87-1.7S210.08,400.44,209.47,401.19Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.18,417.38c.31,1.25,4.56,1.26,9.48,0s8.65-3.24,8.34-4.49-4.55-1.26-9.47,0S194.87,416.14,195.18,417.38Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.62,
    y: 412.86,
    width: 18.37,
    height: 2.33,
    transform: "translate(-94.47 61.91) rotate(-14.06)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,415.13c.31,1.24,4.55,1.26,9.47,0s8.66-3.24,8.34-4.48-4.55-1.26-9.47,0S194.3,413.88,194.62,415.13Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.62,415.13c.31,1.24,4.55,1.26,9.47,0s8.66-3.24,8.34-4.48-4.55-1.26-9.47,0S194.3,413.88,194.62,415.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,414.76a.33.33,0,0,0,.14.19c.37-.89,3.46-2.27,7.36-3.25s7.27-1.22,8-.6a.33.33,0,0,0,0-.24c-.21-.84-3.87-.67-8.16.41S195.52,413.91,195.73,414.76Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,414.76a.33.33,0,0,0,.14.19c.37-.89,3.46-2.27,7.36-3.25s7.27-1.22,8-.6a.33.33,0,0,0,0-.24c-.21-.84-3.87-.67-8.16.41S195.52,413.91,195.73,414.76Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.87,415c.75.62,4.13.38,8-.6s7-2.35,7.36-3.25c-.75-.62-4.12-.37-8,.6S196.24,414.06,195.87,415Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.67,417.59c0,1.28,4,2.5,9.08,2.71s9.22-.65,9.27-1.93-4-2.5-9.07-2.72S186.73,416.3,186.67,417.59Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.73,
    y: 407.63,
    width: 2.33,
    height: 18.37,
    transform: "translate(-228.86 594.84) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,415.26c-.05,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.07-2.71S186.83,414,186.77,415.26Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,415.26c-.05,1.29,4,2.5,9.08,2.72s9.22-.65,9.27-1.94-4-2.5-9.07-2.71S186.83,414,186.77,415.26Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,415.22a.38.38,0,0,0,.08.23c.61-.75,4-1.2,8-1s7.32.9,7.86,1.71a.4.4,0,0,0,.1-.23c0-.87-3.52-1.74-7.94-1.92S188,414.35,187.94,415.22Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.94,415.22a.38.38,0,0,0,.08.23c.61-.75,4-1.2,8-1s7.32.9,7.86,1.71a.4.4,0,0,0,.1-.23c0-.87-3.52-1.74-7.94-1.92S188,414.35,187.94,415.22Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,415.45c.55.81,3.85,1.53,7.86,1.7s7.38-.27,8-1c-.54-.81-3.84-1.53-7.86-1.71S188.63,414.7,188,415.45Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.46,417.48c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.13-2.56-9.34-2.79S281.51,416.16,281.46,417.48Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.75,
    y: 407.25,
    width: 2.39,
    height: 18.89,
    transform: "translate(-137.73 689.67) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56,415.09c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.12-2.56-9.34-2.79S281.61,413.77,281.56,415.09Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.56,415.09c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.12-2.56-9.34-2.79S281.61,413.77,281.56,415.09Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,415.05a.43.43,0,0,0,.08.24c.63-.78,4.08-1.23,8.21-1.06s7.53.92,8.08,1.75a.34.34,0,0,0,.1-.23c0-.89-3.61-1.79-8.16-2S282.8,414.16,282.76,415.05Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,415.05a.43.43,0,0,0,.08.24c.63-.78,4.08-1.23,8.21-1.06s7.53.92,8.08,1.75a.34.34,0,0,0,.1-.23c0-.89-3.61-1.79-8.16-2S282.8,414.16,282.76,415.05Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.84,415.29c.57.82,4,1.57,8.09,1.75s7.58-.28,8.2-1.06c-.55-.83-3.95-1.57-8.08-1.75S283.47,414.51,282.84,415.29Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.47,413.86c-.05,1.32,4.13,2.57,9.34,2.8s9.48-.67,9.53-2-4.12-2.57-9.33-2.8S279.53,412.54,279.47,413.86Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.76,
    y: 403.63,
    width: 2.39,
    height: 18.89,
    transform: "translate(-136 684.24) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,411.47c-.06,1.32,4.12,2.57,9.33,2.8s9.48-.67,9.54-2-4.13-2.57-9.34-2.8S279.63,410.15,279.58,411.47Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,411.47c-.06,1.32,4.12,2.57,9.33,2.8s9.48-.67,9.54-2-4.13-2.57-9.34-2.8S279.63,410.15,279.58,411.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.78,411.43a.43.43,0,0,0,.08.24c.63-.78,4.08-1.23,8.2-1.06s7.54.92,8.09,1.75a.4.4,0,0,0,.1-.23c0-.89-3.62-1.79-8.17-2S280.82,410.54,280.78,411.43Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.78,411.43a.43.43,0,0,0,.08.24c.63-.78,4.08-1.23,8.2-1.06s7.54.92,8.09,1.75a.4.4,0,0,0,.1-.23c0-.89-3.62-1.79-8.17-2S280.82,410.54,280.78,411.43Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.86,411.67c.56.82,4,1.57,8.08,1.75s7.59-.28,8.21-1.06c-.55-.83-3.95-1.57-8.09-1.75S281.49,410.89,280.86,411.67Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.73,411.19c-.06,1.31,4.12,2.56,9.33,2.79s9.48-.67,9.54-2-4.13-2.57-9.34-2.79S283.78,409.87,283.73,411.19Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.01,
    y: 400.95,
    width: 2.39,
    height: 18.89,
    transform: "translate(-129.26 685.91) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,408.79c-.06,1.32,4.12,2.57,9.33,2.8s9.48-.67,9.54-2-4.13-2.57-9.34-2.79S283.88,407.48,283.83,408.79Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,408.79c-.06,1.32,4.12,2.57,9.33,2.8s9.48-.67,9.54-2-4.13-2.57-9.34-2.79S283.88,407.48,283.83,408.79Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,408.75a.43.43,0,0,0,.08.24c.63-.78,4.08-1.23,8.2-1.06s7.54.92,8.09,1.75a.4.4,0,0,0,.1-.23c0-.89-3.62-1.79-8.17-2S285.07,407.86,285,408.75Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,408.75a.43.43,0,0,0,.08.24c.63-.78,4.08-1.23,8.2-1.06s7.54.92,8.09,1.75a.4.4,0,0,0,.1-.23c0-.89-3.62-1.79-8.17-2S285.07,407.86,285,408.75Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,409c.56.83,4,1.57,8.08,1.75s7.59-.28,8.21-1.06c-.55-.83-3.95-1.57-8.09-1.75S285.74,408.21,285.11,409Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,407.57c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.13-2.57-9.34-2.79S283.83,406.25,283.78,407.57Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.07,
    y: 397.33,
    width: 2.39,
    height: 18.89,
    transform: "matrix(0.04, -1, 1, 0.04, -125.59, 682.51)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,405.18c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.13-2.57-9.34-2.79S283.93,403.86,283.88,405.18Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.88,405.18c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.13-2.57-9.34-2.79S283.93,403.86,283.88,405.18Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,405.14a.4.4,0,0,0,.08.23c.63-.78,4.08-1.23,8.2-1.06s7.54.93,8.09,1.75a.34.34,0,0,0,.1-.23c0-.89-3.61-1.79-8.17-2S285.12,404.24,285.08,405.14Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,405.14a.4.4,0,0,0,.08.23c.63-.78,4.08-1.23,8.2-1.06s7.54.93,8.09,1.75a.34.34,0,0,0,.1-.23c0-.89-3.61-1.79-8.17-2S285.12,404.24,285.08,405.14Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.16,405.37c.56.83,4,1.57,8.09,1.75s7.58-.28,8.2-1.06c-.55-.82-3.95-1.57-8.09-1.75S285.79,404.59,285.16,405.37Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.9,404.61c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.12-2.57-9.33-2.79S280,403.29,279.9,404.61Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.19,
    y: 394.37,
    width: 2.39,
    height: 18.89,
    transform: "translate(-126.37 675.77) rotate(-87.56)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,402.22c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.12-2.57-9.33-2.79S280.06,400.9,280,402.22Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,402.22c-.06,1.32,4.12,2.57,9.33,2.79s9.48-.67,9.54-2-4.12-2.57-9.33-2.79S280.06,400.9,280,402.22Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,402.18a.4.4,0,0,0,.08.23c.64-.77,4.09-1.23,8.21-1.05s7.53.92,8.08,1.74a.32.32,0,0,0,.1-.22c0-.9-3.61-1.79-8.16-2S281.24,401.28,281.2,402.18Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,402.18a.4.4,0,0,0,.08.23c.64-.77,4.09-1.23,8.21-1.05s7.53.92,8.08,1.74a.32.32,0,0,0,.1-.22c0-.9-3.61-1.79-8.16-2S281.24,401.28,281.2,402.18Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.28,402.41c.57.83,4,1.58,8.09,1.75s7.58-.28,8.2-1.06c-.55-.82-3.95-1.57-8.08-1.74S281.92,401.64,281.28,402.41Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.26,411.81c-.55,1.17,2.73,3.86,7.32,6s8.76,3,9.3,1.8-2.73-3.85-7.32-6S304.8,410.65,304.26,411.81Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.9,
    y: 405.48,
    width: 2.33,
    height: 18.37,
    transform: "translate(-195.37 521.68) rotate(-64.83)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25,409.71c-.55,1.16,2.73,3.85,7.32,6s8.76,3,9.3,1.8-2.73-3.86-7.32-6S305.79,408.54,305.25,409.71Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25,409.71c-.55,1.16,2.73,3.85,7.32,6s8.76,3,9.3,1.8-2.73-3.86-7.32-6S305.79,408.54,305.25,409.71Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,410.12a.33.33,0,0,0,0,.24c.85-.45,4.12.43,7.75,2.14s6.41,3.66,6.6,4.61a.35.35,0,0,0,.17-.17c.37-.79-2.57-3-6.58-4.85S306.71,409.34,306.34,410.12Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,410.12a.33.33,0,0,0,0,.24c.85-.45,4.12.43,7.75,2.14s6.41,3.66,6.6,4.61a.35.35,0,0,0,.17-.17c.37-.79-2.57-3-6.58-4.85S306.71,409.34,306.34,410.12Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.33,410.36c.19,1,3,2.9,6.59,4.61s6.91,2.6,7.76,2.14c-.19-.95-3-2.9-6.6-4.61S307.18,409.91,306.33,410.36Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.61,415.94c-.05,1.28,4,2.49,9.08,2.71s9.22-.65,9.28-1.93-4-2.5-9.08-2.72S294.67,414.65,294.61,415.94Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.68,
    y: 405.98,
    width: 2.33,
    height: 18.37,
    transform: "translate(-123.85 701.1) rotate(-87.57)",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,413.61c0,1.28,4,2.5,9.08,2.72s9.22-.66,9.27-1.94-4-2.5-9.07-2.71S294.77,412.33,294.71,413.61Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,413.61c0,1.28,4,2.5,9.08,2.72s9.22-.66,9.27-1.94-4-2.5-9.07-2.71S294.77,412.33,294.71,413.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,413.57a.38.38,0,0,0,.08.23c.62-.76,4-1.2,8-1s7.33.9,7.86,1.7a.32.32,0,0,0,.1-.22c0-.87-3.52-1.74-7.94-1.93S295.92,412.7,295.88,413.57Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.88,413.57a.38.38,0,0,0,.08.23c.62-.76,4-1.2,8-1s7.33.9,7.86,1.7a.32.32,0,0,0,.1-.22c0-.87-3.52-1.74-7.94-1.93S295.92,412.7,295.88,413.57Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,413.8c.55.8,3.85,1.53,7.86,1.7s7.38-.27,8-1c-.53-.8-3.84-1.53-7.86-1.7S296.58,413,296,413.8Z",
    style: {
      fill: "#151C62",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.93,159v6a18,18,0,0,1,10.25,4.25l4.27-4.27A24,24,0,0,0,132.93,159Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,201.09a18.05,18.05,0,0,1-16.55-16.55h-6A24.08,24.08,0,0,0,130,207.13Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,181.62A18.07,18.07,0,0,1,130,165.07v-6a24.09,24.09,0,0,0-22.59,22.59Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,181.62A18.07,18.07,0,0,1,130,165.07v-6a24.09,24.09,0,0,0-22.59,22.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,167.11l-4.27,4.27a18.06,18.06,0,0,1-12.31,29.71v6a24.09,24.09,0,0,0,16.58-40Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.93,159v6a18,18,0,0,1,10.25,4.25l4.27-4.27A24,24,0,0,0,132.93,159Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,201.09a18.05,18.05,0,0,1-16.55-16.55h-6A24.08,24.08,0,0,0,130,207.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.47,181.62A18.07,18.07,0,0,1,130,165.07v-6a24.09,24.09,0,0,0-22.59,22.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.51,167.11l-4.27,4.27a18.06,18.06,0,0,1-12.31,29.71v6a24.09,24.09,0,0,0,16.58-40Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-39"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.3 152.66 182.95 163.04 227.03 144.74 270 160.02 308.93 134.85 311.72 138.55 320.97 123.41 300.24 121.79 303.42 125.98 264.46 150.92 222.13 135.9 175.3 152.66",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.3 152.66 182.95 163.04 227.03 144.74 270 160.02 308.93 134.85 311.72 138.55 320.97 123.41 300.24 121.79 303.42 125.98 264.46 150.92 222.13 135.9 175.3 152.66",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356,159.12a9.7,9.7,0,1,0,9.7,9.7A9.7,9.7,0,0,0,356,159.12Zm0,14.55a4.85,4.85,0,1,1,4.84-4.85A4.86,4.86,0,0,1,356,173.67Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.45,187.58a9.7,9.7,0,1,0,9.69,9.7A9.7,9.7,0,0,0,380.45,187.58Zm0,14.54a4.85,4.85,0,1,1,4.84-4.84A4.85,4.85,0,0,1,380.45,202.12Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.63 206.98 353.18 206.98 375.59 159.12 382.04 159.12 359.63 206.98",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356,159.12a9.7,9.7,0,1,0,9.7,9.7A9.7,9.7,0,0,0,356,159.12Zm0,14.55a4.85,4.85,0,1,1,4.84-4.85A4.86,4.86,0,0,1,356,173.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.45,187.58a9.7,9.7,0,1,0,9.69,9.7A9.7,9.7,0,0,0,380.45,187.58Zm0,14.54a4.85,4.85,0,1,1,4.84-4.84A4.85,4.85,0,0,1,380.45,202.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.63 206.98 353.18 206.98 375.59 159.12 382.04 159.12 359.63 206.98",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2--inject-39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245,163.41c.26,1.24.51,2.32.8,3.45s.6,2.19.93,3.33c.65,2.19,1.4,4.37,2.23,6.58a54.29,54.29,0,0,0,6.75,12.92,24.65,24.65,0,0,0,2.76,3.11,15.64,15.64,0,0,0,3.81,2.69,17,17,0,0,0,8.63,1.67,24.11,24.11,0,0,0,7.57-1.78,32.48,32.48,0,0,0,3.32-1.58,16.85,16.85,0,0,0,1.56-1c.5-.37,1-.68,1.56-1.09L282.25,187l-1.4.37-1.47.35c-1,.22-2,.41-3,.54a20.72,20.72,0,0,1-5.45.11,8.93,8.93,0,0,1-4.06-1.46,9.28,9.28,0,0,1-1.44-1.28,18.45,18.45,0,0,1-1.46-2,35.59,35.59,0,0,1-2.65-5c-.82-1.81-1.54-3.72-2.22-5.68s-1.29-4-1.9-6l-.86-3c-.27-1-.57-2.06-.78-2.93Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.09,157.35c4.54-5.77,11.42-3.66,15.29,5.52A89.89,89.89,0,0,1,264.46,178l-16.14,5.67C244.08,175,239.43,163.26,244.09,157.35Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.09,157.35c4.54-5.77,11.42-3.66,15.29,5.52A89.89,89.89,0,0,1,264.46,178l-16.14,5.67C244.08,175,239.43,163.26,244.09,157.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.83,167c-1.32-.9-4.05,4.35-5.31,10.53.89,2.16,1.84,4.23,2.79,6.15l9.71-3.41C256.43,174.46,253.82,169,250.83,167Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.07,184.63l3.53-1.93,1.24,7.88s-5.9,3.56-7.59.62l.18-2A6.48,6.48,0,0,1,283.07,184.63Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.03 182.31 294.12 188.65 287.81 190.59 286.57 182.7 291.03 182.31",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,152.19,235.76,151l-10.29.9a7.16,7.16,0,0,0-6.42,5.84A183.11,183.11,0,0,0,217,180.43c-.36,8.55.59,21.17,2,32.57l34.38-4.16c.33-30,2.6-39.29,2.88-47.24a7.13,7.13,0,0,0-5-7.06Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.42 300.95 261.74 302.98 268.29 285.79 260.99 283.77 254.42 300.95",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,300.7a3.82,3.82,0,0,0-2.35-1.43l-7.53-1.46a.69.69,0,0,0-.81.46L252,305.14a1.52,1.52,0,0,0,.92,1.92H253c2.78,1.1,4.66.72,9,1.56,2.67.52,8.29,2.3,12,2.15s3.75-3.87,2.17-4.15C270.57,305.75,266.28,302.39,265,300.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "268.29 285.8 264.8 294.94 257.6 292.63 260.98 283.77 268.29 285.8"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,235.11a50.56,50.56,0,0,1-1.48,8.06c-1.93,7.46-5.23,15.06-8,22.47C271.7,280.28,267,293,267,293l-10-3.46s9-42.36,15.07-46.69H234.85a15.45,15.45,0,0,1-2.08-.14c6.41-.83,16.4-4.78,25.67-8.73,8.19-3.5,15.85-7,20-8.32h0C283.52,227.83,286.93,230.84,286.54,235.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.54,235.11a50.56,50.56,0,0,1-1.48,8.06c-1.93,7.46-5.23,15.06-8,22.47C271.7,280.28,267,293,267,293l-10-3.46s9-42.36,15.07-46.69H234.85a15.45,15.45,0,0,1-2.08-.14c6.41-.83,16.4-4.78,25.67-8.73,8.19-3.5,15.85-7,20-8.32h0C283.52,227.83,286.93,230.84,286.54,235.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.45,225.7c-4.16,1.35-11.82,4.82-20,8.32-9.27,3.95-19.26,7.9-25.67,8.73-10.8-1.44-14.86-14.31-3.57-29.15,7.33,0,14.7,7,14.7,7S266.07,220.49,278.45,225.7Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.39 286.18 313.57 286.18 305 265.64 299.44 275.07 305.39 286.18",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,284.24l-9.61-2.19a.66.66,0,0,0-.8.43l-2.68,7.39a1.48,1.48,0,0,0,1,1.83h.05c3.37.71,5,.88,9.25,1.83,2.6.6,9.18,2.32,12.77,3.14s4.53-2.7,3.1-3.37c-6.4-3-9.88-5.8-11.74-8.22A2.3,2.3,0,0,0,312.9,284.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "305 265.64 308.65 274.39 301.28 278.5 299.44 275.07 305 265.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.76,271.28l-9,5.45s-7.51-15.77-14.69-33.56a50.56,50.56,0,0,0,1.48-8.06c.39-4.27-3-7.28-8.08-9.4h0c-4.16,1.35-11.82,4.82-20,8.32-9.27,3.95-19.26,7.9-25.67,8.73a18.11,18.11,0,0,1-2.22.16c-12.32,0-16.57-10.8-11.6-29.12,7.33,0,19.88-.79,19.88-.79s24.22-5.82,41.65-3.84a19.67,19.67,0,0,1,17,15.75C302,247.16,308.76,271.28,308.76,271.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.76,271.28l-9,5.45s-7.51-15.77-14.69-33.56a50.56,50.56,0,0,0,1.48-8.06c.39-4.27-3-7.28-8.08-9.4h0c-4.16,1.35-11.82,4.82-20,8.32-9.27,3.95-19.26,7.9-25.67,8.73a18.11,18.11,0,0,1-2.22.16c-12.32,0-16.57-10.8-11.6-29.12,7.33,0,19.88-.79,19.88-.79s24.22-5.82,41.65-3.84a19.67,19.67,0,0,1,17,15.75C302,247.16,308.76,271.28,308.76,271.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,152.19,235.76,151l-10.29.9a7.16,7.16,0,0,0-6.42,5.84A183.11,183.11,0,0,0,217,180.43c-.36,8.55.59,21.17,2,32.57l34.38-4.16c.33-30,2.6-39.29,2.88-47.24a7.13,7.13,0,0,0-5-7.06Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,211.1l-.89,2.79c-.11.21.13.44.5.45l34.32-2.05c.28,0,.52-.13.54-.31l.37-2.8c0-.2-.22-.37-.52-.38l-33.77,2.07A.59.59,0,0,0,218.92,211.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.92,211.1l-.89,2.79c-.11.21.13.44.5.45l34.32-2.05c.28,0,.52-.13.54-.31l.37-2.8c0-.2-.22-.37-.52-.38l-33.77,2.07A.59.59,0,0,0,218.92,211.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,154.94c6.85-1.2,6.51,14.37,3.39,25.76-.9,3.3-4.8,1.92-6.12,1.06C215.34,179,213.88,159.92,222.4,154.94Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.57,178c.26,6.73-1.88,10.26,1.71,12.51s24.8,9.28,25.32,8.4c-1,1.62-2,3-3,4.64q-9.17-1.38-18.35-2.55c-4.47-.56-11.68-1.71-15.18-4.55-3.18-2.56-2.61-13.8-2.07-21.9C212.81,172.88,221.57,178,221.57,178Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.74,152.2c7-2.07,9.71,3.57,7.57,13.26a88.38,88.38,0,0,1-4.63,15.29l-14.74-4.65C209.54,166.59,212.52,154.32,219.74,152.2Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,152.15a6,6,0,0,0,1.07,4.23,18,18,0,0,0,3,3.27c1.39,1.27,3.05,2.64,4.93,2.39,1.73-.23,2.72-1.1,3.42-3.16,1.48,2.39,1.55,3.58,3.18,3.73a3.66,3.66,0,0,0,2.71-1.43,5.92,5.92,0,0,0,2.13-4c.39-3-2.06-5.82-4.92-6.89a36,36,0,0,0-9-1.78C233.85,148.23,230.49,149.06,230,152.15Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,152.15a6,6,0,0,0,1.07,4.23,18,18,0,0,0,3,3.27c1.39,1.27,3.05,2.64,4.93,2.39,1.73-.23,2.72-1.1,3.42-3.16,1.48,2.39,1.55,3.58,3.18,3.73a3.66,3.66,0,0,0,2.71-1.43,5.92,5.92,0,0,0,2.13-4c.39-3-2.06-5.82-4.92-6.89a36,36,0,0,0-9-1.78C233.85,148.23,230.49,149.06,230,152.15Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.16,137.64l3.73,4.31,5.07,5.86a6.55,6.55,0,0,0-1,2.08,3.59,3.59,0,0,0,1.41,4.49c.77.36,1.17,4.41-3.93,4a10.58,10.58,0,0,1-7.69-3.51c-.93-1.25-1.18-1.92-.22-3.29C237.25,147.71,237.47,142.1,237.16,137.64Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.74,146.36l-3.2-4.23c0,.12-.08.26-.12.4a11.18,11.18,0,0,0-.32,1.82c-.19,2.1,1.78,4.79,3.7,5.94l.15-.42a7.91,7.91,0,0,1,1-2,.38.38,0,0,1,.09-.09Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.51,129.71c-.58,6.95-1.22,11,1.76,14.94,4.51,6,13.49,3.86,16.11-2.82,2.36-6,2.85-16.37-3.53-20a9.68,9.68,0,0,0-13.15,3.79A9.56,9.56,0,0,0,237.51,129.71Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.49,135.86l3,1.29h0c1-.42,1.23-1.63,1.16-2.73C240.35,130.18,248,125,248,125s-8.09-2.66-10.52-3.06c-.85-.14-3.91,2.08-4.38,3a8,8,0,0,0,1,8.37A18,18,0,0,0,236.49,135.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,134.61a6.39,6.39,0,0,0,2,4.06c1.48,1.36,3.29-.12,3.51-2.1.18-1.76-.71-4.33-2.51-4.92S233.76,132.67,233.93,134.61Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.94,133.88c-.11.57.1,1.1.47,1.18s.72-.31.87-.88-.11-1.1-.48-1.18S248,133.3,247.94,133.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.35,135.29c-.11.58.1,1.11.48,1.19s.75-.32.86-.88-.11-1.1-.48-1.18S254.46,134.72,254.35,135.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.21,135.26a19.15,19.15,0,0,0,1.22,4.76,2.78,2.78,0,0,1-2.37-.23Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.44,143a4.94,4.94,0,0,1-2.89-2.65.17.17,0,0,1,.09-.22.19.19,0,0,1,.23.1,4.75,4.75,0,0,0,3.29,2.64.17.17,0,0,1,.15.19.18.18,0,0,1-.2.15h0A3.75,3.75,0,0,1,249.44,143Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.06,131.58a.23.23,0,0,1-.14-.09.34.34,0,0,1,0-.48,3.26,3.26,0,0,1,3-.73.34.34,0,0,1,.23.42v0a.34.34,0,0,1-.43.21,2.65,2.65,0,0,0-2.34.59A.31.31,0,0,1,247.06,131.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.08,131.59a.32.32,0,0,1,0-.17.34.34,0,0,1,.42-.24,3.29,3.29,0,0,1,2.3,2,.35.35,0,0,1-.23.43.34.34,0,0,1-.42-.23,2.62,2.62,0,0,0-1.83-1.59A.33.33,0,0,1,255.08,131.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,210.38l43.88.13a3.14,3.14,0,0,0,3.07-2.8l2-22.22a2.55,2.55,0,0,0-2.57-2.82l-43.88-.13a3.15,3.15,0,0,0-3.07,2.81l-2,22.21A2.55,2.55,0,0,0,257.2,210.38Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.2,210.38l43.88.13a3.14,3.14,0,0,0,3.07-2.8l2-22.22a2.55,2.55,0,0,0-2.57-2.82l-43.88-.13a3.15,3.15,0,0,0-3.07,2.81l-2,22.21A2.55,2.55,0,0,0,257.2,210.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,210.29l43.88.13a3.14,3.14,0,0,0,3.07-2.81l2-22.21a2.54,2.54,0,0,0-2.56-2.82L261,182.45a3.16,3.16,0,0,0-3.07,2.81l-2,22.21A2.54,2.54,0,0,0,258.49,210.29Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,210.29l43.88.13a3.14,3.14,0,0,0,3.07-2.81l2-22.21a2.54,2.54,0,0,0-2.56-2.82L261,182.45a3.16,3.16,0,0,0-3.07,2.81l-2,22.21A2.54,2.54,0,0,0,258.49,210.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.77,196.75a3.1,3.1,0,1,1-2.77-3.4A3.1,3.1,0,0,1,284.77,196.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,210.39c0,1.33-.79,2.41-1.75,2.41h0l-45.29-.18c-.49,0-.89-.54-.89-1.2s.4-1.22.89-1.22Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,210.39c0,1.33-.79,2.41-1.75,2.41h0l-45.29-.18c-.49,0-.89-.54-.89-1.2s.4-1.22.89-1.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.68,212.63h-21.8a2.1,2.1,0,0,1-2.1-2.1h0a.32.32,0,0,1,.32-.33h23.58a1.21,1.21,0,0,1,1.21,1.22h0A1.21,1.21,0,0,1,255.68,212.63Z",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9,195.8l3.62-1.06-.33,8.91s-7.86,1.85-8.35-1.77l1-1.95C240.71,198.25,241.91,196.29,243.9,195.8Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.94 197.21 251.87 202.21 247.19 203.64 247.52 194.74 252.94 197.21",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.37 288.81 269.37 293.9 272.44 287.7 255.85 282.43 254.37 288.81",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.46 277.96 311.29 270.24 308.75 263.81 293.72 272.59 297.46 277.96",
    style: {
      fill: "#151C62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,129.64c2.06-.12,2.9-2.55,2.65-3.59a5.34,5.34,0,0,0-2.32-3.33c.66-2-.23-4.44-2.71-6.13a6.9,6.9,0,0,0-6-.44c0-1.81-3.33-3-5.47-.74a4.8,4.8,0,0,0-5.73.51,2,2,0,0,0-.64,1.93,4.73,4.73,0,0,0-3.88,7.35c.67,1,2.26,1,3.46.74a4.81,4.81,0,0,0,3.09,2.27c3.95,1.31,9.38.08,10.34,0a4,4,0,0,1,2.77.55,2.1,2.1,0,0,1-1.57.87,5.92,5.92,0,0,1-1.78-.09,6.23,6.23,0,0,0,4.54.93,21.15,21.15,0,0,1,2.08-.91C257,129.49,257.74,129.71,257.69,129.64Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel3);
export default __webpack_public_path__ + "static/media/model3.8e79e0cbf2ab062eded4e8eda646ccce.svg";
export { ForwardRef as ReactComponent };